import { setIsMaintenance } from "../login/reducer";

export function checkMaintenance(dispatch, res) {
  if (res?.message === 'maintenance') {
    dispatch(setIsMaintenance(true));
    return;
  }
}